export const menus = [
	{
		name: 'About Us',
		link: 'About'
	},
	{
		name: 'Contact Us',
		link: 'Contact'
	},
]